import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Checkbox from "../../Components/checkbox/Checkbox";
import ApiDropdown from "../../Components/DropDown/Apidropdown";
import FileUploader from "../../Components/FileUpload/FileUpload";
import Input from "../../Components/input/input";
import TaskGridLookupModal, {
  toRelatedItems,
} from "../../Components/Lookup/IncidentLookUp";
import config from "../../config";
import "../../Style/IncidentAdd.css";
import { ChangeData } from "../../utils/Change/changeTypes";
import { IncidentData } from "../../utils/Incident/incidentTypes";
import { useFetchFullName } from "../Incidents/Hooks/useFetchFullName";
import { Task, initialTask } from "./Task";
import TextArea from "../../Components/TextArea/TextArea";
import ses from "../../Assets/ses.jpg";
import { authFetch } from "../../utils/Security/authFetch";
import { joinMulti, splitMulti } from "../../utils/multiValue";
import Button from "../../Components/button/button";
import { RmaData } from "../../utils/Rma/rmaTypes";
import { KnowledgeBaseData } from "../../utils/KnowledgeBase/KnowledgeBaseTypes";
import { ProblemData } from "../../utils/Problem/problemTypes";
import { TaskData } from "../../utils/Task/taskTypes";
import { getSignatureLines } from "../../utils/emailSignature";

const TaskAdd: React.FC = () => {
  const [task, setTask] = useState<Task>(initialTask);
  const [isTaskLookupOpen, setIsTaskLookupOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState<
    (
      | IncidentData
      | ChangeData
      | RmaData
      | KnowledgeBaseData
      | ProblemData
      | TaskData
    )[]
  >([]);
  const [customer, setCustomer] = useState<
    string | number | (string | number)[] | null
  >(null);
  const [network, setNetwork] = useState<
    string | number | (string | number)[] | null
  >(null);
  const [site, setSite] = useState<
    string | number | (string | number)[] | null
  >(null);
  const [emails, setEmails] = useState<[]>();
  const [msoEmails, setMsoEmails] = useState<string[] | undefined>(undefined);

  const username = localStorage.getItem("username");
  const organization = localStorage.getItem("organization") || undefined;
  const isAdmin = localStorage.getItem("isAdmin") === "true";
  const isForTelebras = localStorage.getItem("isForTelebras") === "true";
  const isForPetrobras = localStorage.getItem("isForPetrobras") === "true";
  const handleOpenTaskLookup = () => setIsTaskLookupOpen(true);
  const handleCloseTaskLookup = () => setIsTaskLookupOpen(false);
  const isallsite = localStorage.getItem("isAllSite");
  const isallnetwork = localStorage.getItem("isAllNetwork");
  const isalllink = localStorage.getItem("isAllLink");
  const navigate = useNavigate();
  const location = useLocation();
  const changeData = (location.state as any)?.changeData as
    | ChangeData
    | undefined;
  const handleTaskSelect = (
    tasks: (
      | IncidentData
      | ChangeData
      | RmaData
      | KnowledgeBaseData
      | ProblemData
      | TaskData
    )[]
  ) => {
    const ticketIds = tasks.map((t) => t.ticketId);
    handleChange("relatedobject", ticketIds);
    setSelectedTask(tasks);
  };
  const toStringArray = (v: unknown): string[] => {
    if (v == null) return [];
    if (Array.isArray(v)) return v.map(String);
    if (typeof v === "string") return [v];
    return [String(v)];
  };
  const toDatetimeLocal = (v: unknown): string => {
    if (!v) return "";
    const s = String(v);

    // already correct: 2025-10-24T09:00
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(s)) return s;

    // with seconds: 2025-10-24T09:00:00  -> 2025-10-24T09:00
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(s)) return s.slice(0, 16);

    // with space: 2025-10-24 09:00:00 -> 2025-10-24T09:00
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(s))
      return s.replace(" ", "T").slice(0, 16);

    return "";
  };
  const firstString = (v: unknown): string | undefined => {
    const arr = toStringArray(v);
    return arr?.[0];
  };
  useEffect(() => {
    console.log("dataaaaaaaaaaaaaaaaaa", changeData);
    if (!changeData) return;

    const affectedCustomer = toStringArray(
      (changeData as any).affectedCustomer
    );
    const affectedNetwork = toStringArray((changeData as any).affectedNetwork);
    const affectedSite = toStringArray((changeData as any).affectedSite);
    const affectedLink = toStringArray((changeData as any).affectedLink);
    const start = toDatetimeLocal((changeData as any).changeStartDatetime);
    const end = toDatetimeLocal((changeData as any).changeCloseDatetime);
    const imapctstart = toDatetimeLocal(
      (changeData as any).imapctchangeStartDatetime
    );
    const impactend = toDatetimeLocal(
      (changeData as any).impactchangeCloseDatetime
    );

    setTask((prev) => ({
      ...prev,
      affectedCustomer: affectedCustomer.length
        ? affectedCustomer
        : prev.affectedCustomer,
      affectedNetwork: affectedNetwork.length
        ? affectedNetwork
        : prev.affectedNetwork,
      affectedSite: affectedSite.length ? affectedSite : prev.affectedSite,
      affectedLink: affectedLink.length ? affectedLink : prev.affectedLink,

      summary: prev.summary || (changeData as any).summary || "",
      description: prev.description || (changeData as any).description || "",
      priority: prev.priority || (changeData as any).priority || "",
      taskStartDatetime: prev.taskStartDatetime || start,
      taskCloseDatetime: prev.taskCloseDatetime || end,
      imapcttaskStartDatetime: prev.imapcttaskStartDatetime || imapctstart,
      impacttaskCloseDatetime: prev.impacttaskCloseDatetime || impactend,
      relatedobject: [changeData.ticketId],
    }));

    setCustomer(affectedCustomer.length ? affectedCustomer : null);
    setNetwork(affectedNetwork.length ? affectedNetwork : null);
    setSite(affectedSite.length ? affectedSite : null);

    setSelectedTask([changeData]);
  }, [changeData]);

  useEffect(() => {
    const fetchEmails = async () => {
      try {
        const response = await authFetch(`${config.apiBaseUrl}/api/chm`);
        if (!response.ok) {
          throw new Error("Failed to fetch emails");
        }
        const data = await response.json();
        setMsoEmails(data);
      } catch (err: any) {
        console.error("Email fetch failed:", err);
      } finally {
      }
    };

    fetchEmails();
  }, []);

  useEffect(() => {
    if (isAdmin && isForPetrobras) {
      const fetchData = async () => {
        try {
          const responseIds = await authFetch(
            `${config.apiBaseUrl}/api/users/id-by-organization?organization=Petrobras`
          );

          if (!responseIds.ok) throw new Error("Failed");

          const userIds = await responseIds.json();

          const userIdsParam = Array.isArray(userIds)
            ? userIds.join(",")
            : userIds;

          const responseEmails = await authFetch(
            `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`
          );

          const emails = await responseEmails.json();

          setEmails(emails);

          handleChange("foruserid", userIds);
          handleChange("affectedCustomer", ["Petrobras"]);
        } catch (error) {
          console.error(error);
        }
      };

      fetchData();
    }
  }, [isAdmin, isForPetrobras]);

  useEffect(() => {
    const storedUsername = localStorage.getItem("username");
    const storedPosition = localStorage.getItem("position") ?? "";
    if (storedUsername) {
      setTask((prev) => ({
        ...prev,
        createdby: storedUsername,
        responsiblePerson: storedUsername,
        responsibleTeam: storedPosition,
      }));
    }
  }, []);
  useEffect(() => {
    const { urgency, impact } = task;
    if (!urgency || !impact) return;

    const key = `${urgency}-${impact}`;
    let priority = "";

    if (key === "Critical-Critical" || key === "High-Critical")
      priority = "Critical";
    else if (
      key === "Critical-High" ||
      key === "High-High" ||
      key === "Medium-Critical"
    )
      priority = "High";
    else if (
      key === "Critical-Medium" ||
      key === "High-Medium" ||
      key === "Medium-High" ||
      key === "Medium-Medium"
    )
      priority = "Medium";
    else if (
      key === "Low-Low" ||
      key === "Low-Medium" ||
      key === "Low-High" ||
      key === "Low-Medium"
    )
      priority = "Low";

    setTask((prev) => ({
      ...prev,
      priority,
    }));
  }, [task.urgency, task.impact]);
  useFetchFullName((fullName: string) => {
    setTask((prev) => ({ ...prev, user: fullName }));
  });

  const handleChange = (field: keyof Task, value: any) => {
    setTask((prev) => {
      const updated = { ...prev, [field]: value };

      // Apply "All" logic
      updated.affectedSite =
        isallsite === "true" ? ["All Sites"] : updated.affectedSite;
      updated.affectedLink =
        isalllink === "true" ? ["All Links"] : updated.affectedLink;
      updated.affectedNetwork =
        isallnetwork === "true" ? ["All Networks"] : updated.affectedNetwork;

      // Validate Planned Dates
      if (
        (field === "taskCloseDatetime" || field === "taskStartDatetime") &&
        updated.taskCloseDatetime &&
        updated.taskStartDatetime &&
        new Date(updated.taskCloseDatetime) <
          new Date(updated.taskStartDatetime)
      ) {
        alert("Planned end Date/Time must be after Planned start Date/Time");
        return prev; // Reject update
      }

      // Validate Impact Planned Dates
      if (
        (field === "impacttaskCloseDatetime" ||
          field === "imapcttaskStartDatetime") &&
        updated.impacttaskCloseDatetime &&
        updated.imapcttaskStartDatetime &&
        new Date(updated.impacttaskCloseDatetime) <
          new Date(updated.imapcttaskStartDatetime)
      ) {
        alert(
          "Impact Planned end Date/Time must be after Impact Planned start Date/Time"
        );
        return prev; // Reject update
      }

      return updated; // Accept update
    });
  };

  const validateForm = (): boolean => {
    if (!task) {
      alert("Task data is not available.");
      return false;
    }

    const requiredFields: (keyof Task)[] = [
      "taskStartDatetime",
      "taskCloseDatetime",
      "summary",
      "description",
      "tasktype",
    ];

    for (const field of requiredFields) {
      const value = task[field];
      if (
        value === undefined ||
        value === null ||
        value.toString().trim() === ""
      ) {
        alert(`Please fill the required field`);
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async () => {
    const updatedTask = {
      ...task,
      customerInformed: isAdmin ? task.customerInformed : true,
    };

    const formattedDate = updatedTask.taskStartDatetime.replace("T", " ");
    const formattedDateClose = updatedTask.taskCloseDatetime.replace("T", " ");

    if (!validateForm()) return;
    task.user = "";

    try {
      const response = await authFetch(`${config.apiBaseUrl}/api/tasks`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(task),
      });
      const isallsite = localStorage.getItem("isAllSite");
      const isallnetwork = localStorage.getItem("isAllNetwork");
      const isalllink = localStorage.getItem("isAllLink");
    
      const siteInfo =
        isallsite === "true" ? "All Sites" : updatedTask.affectedSite ?? "";
      const linkInfo =
        isalllink === "true" ? "All Links" : updatedTask.affectedLink ?? "";
      const networkInfo =
        isallnetwork === "true"
          ? "All Networks"
          : updatedTask.affectedNetwork ?? "";
      if (!response.ok) throw new Error("Failed to submit task");
      const jackson = ["jacksondoumith006@gmail.com"];
      const savedIncident = await response.json();
      updatedTask.ticketId = savedIncident.ticketId;
    
      try {
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
      to: msoEmails,
      subject: `Task ID ${updatedTask.ticketId} | ${updatedTask.affectedCustomer} | - Added to you`,
      body: `
      <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
      <p>Hello,</p>
      <p>A ticket with ID ${updatedTask.ticketId} has been opened with the following comment</p>
      <p><strong>Customer:</strong> ${updatedTask.affectedCustomer}<br><br>
      <strong>Network:</strong> ${updatedTask.affectedNetwork}<br><br>
      <strong>Site:</strong> ${updatedTask.affectedSite}<br><br>
      <strong>Link:</strong> ${updatedTask.affectedLink}<br><br>
      <strong>Task Start Date:</strong> ${formattedDate}<br><br>
      <strong>Task Close Date:</strong> ${formattedDateClose}<br><br><br>
      <strong>Summary:</strong> ${updatedTask.summary}<br><br>
      <strong>Description:</strong> ${updatedTask.description}<br><br>
      <strong>Closure Code:</strong> ${updatedTask.closureCode}<br><br>
      <strong>Solution:</strong> ${updatedTask.solution}</p>
      <p>
      <p>Regards,<br><br></p>
    
      <a href="https://bdm.bcomsat.com/task-edit/${updatedTask.ticketId}" target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
      👉 View Task Details
      </a>
      </p>
      <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
      <td style="vertical-align: top; padding-right: 12px;">
    
      <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
    
      </td>
    
      <td>
      <div style="
      padding: 12px;
      border-left: 4px solid #2a1364;
      background-color: #f9f9f9;
      color: #2a1364;
      font-size: 13px;
      ">
      <strong>Managed Services Operations</strong><br>
      ${getSignatureLines(updatedTask.affectedCustomer, "#2a1364")}
             </div>
           </td>
        </tr>
      </table>
              </div>
            `,
            }),
         });
    
         localStorage.setItem("email", task.email);
       } catch (emailErr) {
          console.error("Failed to send email notification:", emailErr);
       }
    
      alert("Task submitted successfully!");
      setTask({ ...initialTask, ticketId: task.ticketId });
      navigate("/task");
    } catch (error) {
      alert(`Submission error: ${(error as Error).message}`);
      console.error(`Submission error: ${(error as Error).message}`);
    }
  };

  // Generate Ticket ID once
  useEffect(() => {
    if (!task.ticketId) {
      const randomId = `TSK${Math.floor(10000 + Math.random() * 90000)}`;
      setTask((prev) => ({ ...prev, ticketId: randomId }));
    }
  }, []);

  return (
    <div className="incident-form">
      <section className="form-section">
        <h3>Task Information</h3>
        <div className="grid">
          <Input
            type="text"
            label="Created By"
            value={task.createdby ?? ""}
            onChange={(val) => handleChange("createdby", val)}
            readOnly
          />
          {isAdmin && (
            <ApiDropdown
              api="users/fullnames"
              labelKey="fullName"
              valueKey="id"
              label="User"
              onChange={async (val) => {
                handleChange("userid", val);
                try {
                  const res = await authFetch(
                    `${config.apiBaseUrl}/api/users/${val}`
                  );
                  if (!res.ok) throw new Error("User not found");
                  const user = await res.json();
                  handleChange("email", user.email);
                } catch (err) {
                  console.error("Error fetching user:", err);
                }
              }}
            />
          )}
          {!isAdmin && (
            <ApiDropdown
              api={`users/by-organization/${organization}`}
              labelKey="username"
              valueKey="id"
              label="User"
              onChange={async (val) => {
                handleChange("userid", val);
                try {
                  const res = await authFetch(
                    `${config.apiBaseUrl}/api/users/${val}`
                  );
                  if (!res.ok) throw new Error("User not found");
                  const user = await res.json();
                  handleChange("email", user.email);
                } catch (err) {
                  console.error("Error fetching user:", err);
                }
              }}
            />
          )}
          <Input
            readOnly
            type="text"
            label="Ticket ID"
            value={task.ticketId || ""}
            onChange={() => {}}
          />

          {/* <Input type="datetime-local" label="Ticket creation" value={task.ticketCreation} onChange={(val) => handleChange('ticketCreation', val)} /> */}
          {/* <Input type="datetime-local" label="Ticket closure" value={task.ticketClosure} onChange={(val) => handleChange('ticketClosure', val)} /> */}

          <Input
            type="datetime-local"
            label="Planned Start Date/Time (UTC)"
            required={true}
            value={task.taskStartDatetime}
            onChange={(val) => handleChange("taskStartDatetime", val)}
          />
          <Input
            type="datetime-local"
            label="Planned End Date/Time (UTC)"
            required={true}
            value={task.taskCloseDatetime}
            onChange={(val) => handleChange("taskCloseDatetime", val)}
          />
          <Input
            type="datetime-local"
            label="Impact Planned Start Date/Time (UTC)"
            value={task.imapcttaskStartDatetime}
            onChange={(val) => handleChange("imapcttaskStartDatetime", val)}
          />
          <Input
            type="datetime-local"
            label="Impact Planned end Date/Time (UTC)"
            value={task.impacttaskCloseDatetime}
            onChange={(val) => handleChange("impacttaskCloseDatetime", val)}
          />
          <Checkbox
            label="Customer Approval"
            onChange={(e) => handleChange("customerapproval", e.target.checked)}
            checked={task.customerapproval}
          />
        </div>
      </section>
      <section className="form-section">
        <h3>Customer & Network</h3>
        <div className="grid">
          {!isAdmin && !isForTelebras && !isForPetrobras && (
            <ApiDropdown
              api="affected-customers"
              required={true}
              labelKey="customername"
              disabled
              value={organization}
              valueKey="customername"
              label="Customer"
              isMulti
              onOpen={async () => {
                try {
                  const responseIds = await authFetch(
                    `${config.apiBaseUrl}/api/users/id-by-organization?organization=${organization}`
                  );
                  if (!responseIds.ok)
                    throw new Error(
                      `HTTP error! status: ${responseIds.status}`
                    );
                  const userIds = await responseIds.json();
                  //console.log("Fetched user IDs:", userIds);

                  const userIdsParam = Array.isArray(userIds)
                    ? userIds.join(",")
                    : userIds;
                  const responseEmails = await authFetch(
                    `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`
                  );
                  if (!responseEmails.ok)
                    throw new Error(
                      `HTTP error! status: ${responseEmails.status}`
                    );
                  const emails = await responseEmails.json();
                  setEmails(emails);
                  //console.log("Fetched emails:", emails);

                  handleChange("foruserid", userIds);

                  handleChange("affectedCustomer", [organization]);
                } catch (error) {
                  console.error("Failed to fetch customer or emails:", error);
                }
              }}
            />
          )}
          {isAdmin && !isForTelebras && !isForPetrobras && (
            <ApiDropdown
              api="affected-customers"
              labelKey="customername"
              required={true}
              value={task.affectedCustomer}
              valueKey="customername"
              label="Customer"
              isMulti
              onChange={async (val) => {
                setCustomer(val);
                handleChange("affectedCustomer", val);
                try {
                  const responseIds = await authFetch(
                    `${config.apiBaseUrl}/api/users/id-by-organization?organization=${val}`
                  );
                  if (!responseIds.ok)
                    throw new Error(
                      `HTTP error! status: ${responseIds.status}`
                    );
                  const userIds = await responseIds.json();
                  //console.log("Fetched user IDs:", userIds);

                  const userIdsParam = Array.isArray(userIds)
                    ? userIds.join(",")
                    : userIds;
                  const responseEmails = await authFetch(
                    `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`
                  );
                  if (!responseEmails.ok)
                    throw new Error(
                      `HTTP error! status: ${responseEmails.status}`
                    );
                  const emails = await responseEmails.json();
                  setEmails(emails);
                  //console.log("Fetched emails:", emails);

                  handleChange("foruserid", userIds);
                } catch (error) {
                  console.error("Failed to fetch customer or emails:", error);
                }
              }}
            />
          )}
          {isAdmin && isForPetrobras && (
            <ApiDropdown
              api="affected-customers"
              required
              labelKey="customername"
              valueKey="customername"
              label="Customer"
              value={"Petrobras"}
              disabled
            />
          )}
          {isAdmin && isForPetrobras && (
            <ApiDropdown
              api={`everything/networks?customer=Petrobras`}
              labelKey="label"
              valueKey="value"
              label=" Networks"
              required={true}
              isMulti
              onChange={(val) => {
                setNetwork(val);
                handleChange("affectedNetwork", val);
              }}
            />
          )}
          {!isAdmin && organization && (
            <ApiDropdown
              api={`everything/networks?customer=${organization}`}
              labelKey="label"
              valueKey="value"
              label=" Networks"
              required={true}
              isMulti
              onChange={(val) => {
                setNetwork(val);
                handleChange("affectedNetwork", val);
              }}
            />
          )}

          {!isAdmin && organization && (
            <>
              {network && (
                <ApiDropdown
                  api={`everything/sites?customer=${organization}&network=${network}`}
                  labelKey="label"
                  required={true}
                  valueKey="value"
                  label=" Site"
                  isMulti
                  onChange={(val) => {
                    setSite(val);
                    handleChange("affectedSite", val);
                  }}
                />
              )}

              {site && (
                <ApiDropdown
                  api={`everything/links?customer=${organization}&network=${network}&site=${site}`}
                  labelKey="label"
                  valueKey="value"
                  label=" Link"
                  isMulti
                  onChange={(val) => handleChange("affectedLink", val)}
                />
              )}

              <ApiDropdown
                api={`everything/asset?customer=${organization}&network=${network}`}
                labelKey="label"
                valueKey="value"
                label="Assets"
                isMulti
                value={splitMulti(task.asset)}
                onChange={(val) => handleChange("asset", joinMulti(val))}
              />
            </>
          )}

          {isAdmin && (
            <>
              {customer && (
                <ApiDropdown
                  api={`everything/networks?customer=${customer}`}
                  labelKey="label"
                  valueKey="value"
                  label="Networks"
                  isMulti
                  value={task.affectedNetwork}
                  required={true}
                  onChange={(val) => {
                    setNetwork(val);
                    handleChange("affectedNetwork", val);
                  }}
                />
              )}

              {network && !isForTelebras && !isForPetrobras && (
                <ApiDropdown
                  api={`everything/sites?customer=${customer}&network=${network}`}
                  labelKey="label"
                  valueKey="value"
                  label="Site"
                  isMulti
                  value={task.affectedSite}
                  onChange={(val) => {
                    setSite(val);
                    handleChange("affectedSite", val);
                  }}
                />
              )}

              {network && isForPetrobras && (
                <ApiDropdown
                  api={`everything/sites?customer=Petrobras&network=${network}`}
                  labelKey="label"
                  valueKey="value"
                  label="Site"
                  isMulti
                  value={task.affectedSite}
                  onChange={(val) => {
                    setSite(val);
                    handleChange("affectedSite", val);
                  }}
                />
              )}

              {site && !isForTelebras && !isForPetrobras && (
                <ApiDropdown
                  api={`everything/links?customer=${customer}&network=${network}&site=${site}`}
                  labelKey="label"
                  valueKey="value"
                  label="Link"
                  isMulti
                  value={task.affectedLink}
                  onChange={(val) => handleChange("affectedLink", val)}
                />
              )}

              {site && isForPetrobras && (
                <ApiDropdown
                  api={`everything/links?customer=Petrobras&network=${network}&site=${site}`}
                  labelKey="label"
                  valueKey="value"
                  label="Link"
                  isMulti
                  value={task.affectedLink}
                  onChange={(val) => handleChange("affectedLink", val)}
                />
              )}

              <ApiDropdown
                api={`everything/asset?customer=${ customer
                }&network=${network}`}
                labelKey="label"
                valueKey="value"
                label="Assets"
                isMulti
                value={splitMulti(task.asset)}
                onChange={(val) => handleChange("asset", joinMulti(val))}
              />
              <ApiDropdown
                api={`everything/antenna?customer=${customer}`}
                labelKey="label"
                valueKey="value"
                label="Antennas"
                isMulti
                value={splitMulti(task.affectedAntenna)}
                onChange={(val) => handleChange("affectedAntenna", joinMulti(val))}
              />
            </>
          )}
        </div>
      </section>
      <section className="form-section">
        <h3>Task Severity</h3>
        <div className="grid">
          <ApiDropdown
            api="Urgencys"
            required
            labelKey="name"
            valueKey="name"
            label="Priority"
            value={task.priority}
            onChange={(val) => handleChange("priority", val)}
          />
        </div>
      </section>
      <section className="form-section">
        <h3>Task Details</h3>
        <div className="grid2">
          <TextArea
            label="Summary"
            required={true}
            style={{
              minHeight: "30px",
              minWidth: "90%",
              backgroundColor: "white",
            }}
            value={task.summary}
            onChange={(val: any) => handleChange("summary", val)}
          />
          <TextArea
            label="Description"
            required={true}
            style={{
              minHeight: "100px",
              minWidth: "90%",
              backgroundColor: "white",
            }}
            value={task.description}
            onChange={(val: any) => handleChange("description", val)}
          />
        </div>
        <div className="grid">
          <ApiDropdown
            api="Tasktypes"
            labelKey="name"
            valueKey="name"
            required
            label="Type of task"
            onChange={(val) => handleChange("tasktype", val)}
          />
        </div>
      </section>

      <section className="form-section">
        <h3>Responsibilty</h3>
        <div className="grid">
          <>
            {isAdmin && (
              <Input
                type="text"
                label="Responsible Person"
                value={task.responsiblePerson}
                onChange={(val) => handleChange("responsiblePerson", val)}
                readOnly
              />
            )}
            {isAdmin && (
              <Input
                type="text"
                label="Responsible Team"
                value={task.responsibleTeam}
                onChange={(val) => handleChange("responsibleTeam", val)}
                readOnly
              />
            )}
          </>
        </div>
      </section>

      <section className="form-section">
        <h3>Related object</h3>
        <div className="grid"></div>
        <>
          <FileUploader
            value={task.filePath}
            onRemove={(path) =>
              handleChange("filePath", (task.filePath || []).filter((p: any) => p !== path))
            }
            onChange={async (files, paths) => {
              if (!files || !paths.length) return;

              const uploadedPaths: string[] = [];

              for (let i = 0; i < files.length; i++) {
                const safeFileName = files[i].name.replace(/\s+/g, "_");

                // Create a new File object with the updated name
                const renamedFile = new File([files[i]], safeFileName, {
                  type: files[i].type,
                });

                const formData = new FormData();
                formData.append("file", renamedFile);

                try {
                  const response = await authFetch(
                    `${config.apiBaseUrl}/api/tasks/upload`,
                    {
                      method: "POST",
                      body: formData,
                    }
                  );

                  if (response.ok) {
                    let { path } = await response.json();

                    path = path.replace(/\s+/g, "_");

                    uploadedPaths.push(path);
                    console.log(
                      "jacksonnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnn",
                      uploadedPaths
                    );
                  } else {
                    console.error(`Upload failed for file: ${safeFileName}`);
                  }
                } catch (error) {
                  console.error("Error uploading file", error);
                }
              }

              if (uploadedPaths.length) {
                handleChange("filePath", [
                  ...(task.filePath || []),
                  ...uploadedPaths,
                ]);
              }
            }}
          />
          {!isForTelebras  && (
            <button onClick={handleOpenTaskLookup}>Select Related Ticket</button>
          )}
            {toRelatedItems(task.relatedobject).length > 0 && (
            <div>
              <p>
                <strong>Selected Tasks:</strong>
              </p>
              <ul>
                {toRelatedItems(task.relatedobject).map((task, index) => (
                  <li key={index}>{task.ticketId}</li>
                ))}
              </ul>
            </div>
          )}
          <TaskGridLookupModal
            isOpen={isTaskLookupOpen}
            onClose={handleCloseTaskLookup}
            onSelect={handleTaskSelect}
            selectedItems={toRelatedItems(task.relatedobject)}
          />
        </>
      </section>

      <div className="submit-section">
        <Button onClick={handleSubmit}>Submit Task</Button>
      </div>
    </div>
  );
};

export default TaskAdd;
